import { bindHTTP } from '@frontend/schema';
import { PhoneCallQueueConfigService } from '@weave/schema-gen-ts/dist/schemas/phone/callqueue-config/v1/callqueue_config_service.pb';
const SchemaPhoneCallQueueConfigService = bindHTTP(PhoneCallQueueConfigService);

export default SchemaPhoneCallQueueConfigService;
